<!--
Menu to display all app items.
@author ab557z
-->
<template>
  <div id="contain" class="container">
    <div id="loginLogo2">
      <img class="loginLogoImg" src="@/assets/UofG_App_Logo.svg" alt="University of Glasgow Logo" height="110"/>
    </div>
    <div v-if="internet" style="text-align:center;margin-left:24px;margin-right:24px;padding-top:24px;">
      <img :src="maintenanceImg"/>
      <p  style="display:inline-block;color:#003865;font-weight:bold;">Looks like we are doing some maintenance right now... please come back later!</p>
    </div>
    <div v-if="!internet" style="text-align:center;margin-left:24px;margin-right:24px;padding-top:24px;">
      <img :src="noInternetImg"/>
      <p  style="display:inline-block;color:#003865;font-weight:bold;">Looks like you might not be connected to the internet right now.. please check your connection and try again!</p>
    </div>
    <div style="text-align:center; margin-left:24px;margin-right:24px;">
      <button class="goToLoginBtn" @click="go('login')">Go to login</button>
      <button class="helpdeskBtn" @click="goOut('https://www.gla.ac.uk/myglasgow/it/helpdesk/')" v-if="internet">Check the helpdesk for more info</button>
    </div>
  </div>
</template>
 <!--    <h5>Level 1</h5>
<vm-progress :percentage="update" type="circle"
>Hello</vm-progress>

 <vm-progress :percentage="update" :text-inside="true" :stroke-width="18" status="info"></vm-progress>  -->

<script>
// import axios from 'axios'
// import Logo from '@/components/Logo.vue'
// import $cookies from 'vue-cookies'
import noInternetImg from '@/assets/no_internet.svg'
import maintenanceImg from '@/assets/maintenance.svg'
export default {
  name: 'Menu',
  components: {
    //    Logo
  },
  data () {
    return {
      internet: true,
      noInternetImg,
      maintenanceImg
    }
  },
  mounted () {
    fetch('https://1.1.1.1', {
      mode: 'no-cors'
    })
      .then(response => {
        if (response.status != 200) {
          this.internet = true
        }
      })
      .catch(err => {
        console.error(err)
        this.internet = false
      })
  },
  methods: {
    goOut (path) {
      window.open(path)
    }
  }
}
</script>
<style>
#loginLogo2 {
  padding-top:40px;
  height:200px;
  background-color:#003865;
  text-align:center;
}

.goToLoginBtn {
  background-color:#003865;
  width:100%;
  color:#ffffff;
  font-family:PTSans;
  border: 1px solid #003865;
  border-radius:12px;
  height:52px;
  margin-top:24px;
  margin-bottom:21px;
  font-weight:700;
}

.helpdeskBtn {
  background-color:#ffffff;
  width:100%;
  color:#003865;
  font-family:PTSans;
  border: 1px solid #003865;
  border-radius:12px;
  height:52px;
  margin-bottom:21px;
  font-weight:700;
}

</style>
